module.exports = __webpack_public_path__ + "images/emoji/musical_score.afc95f52cdfdf777e0f9.png";